<div class="connection-content">

  <h3 class="connection-info-heading">My Connections</h3>
  <hr class="connection-info-divider">
  <div *ngFor="let connection of (connections$ | async); let i = index;"
    [ngClass]="(connections$ | async)?.length !== i + 1 ? 'row contact-row mos-u-spacer--margin-bottom-sm' : 'row contact-row'">
    <div *ngIf="(connection?.profileImageId)" class="columns small-12 medium-1">
      <atlas-avatar *ngIf="loading[connection?.profileImageId]" [imgAlt]="'Profile Image'">
        {{connection.firstName.substring(0, 1)}}{{connection.lastName.substring(0, 1)}}
      </atlas-avatar>
      <img [hidden]="loading[connection?.profileImageId]" (load)="onLoad(connection?.profileImageId)"
        class="profileImage" [src]="(profileImageDataUrl$[connection?.profileImageId] | async) || ''" />
    </div>
    <div *ngIf="!(connection?.profileImageId)" class="columns small-12 medium-1">
      <atlas-avatar *ngIf="!(connection?.profileImageId)" [imgAlt]="'Profile Image'">
        {{connection.firstName.substring(0, 1)}}{{connection.lastName.substring(0, 1)}}
      </atlas-avatar>

    </div>
    <div class="columns medium-2 small-12">
      <h4>{{connection.lastName}}, {{connection.firstName}}</h4>
    </div>
    <div class="columns medium-9 small-12 contact-details">
      <h5>
        <atlas-icon [icon]="'icon-phone-24'" [size]="'large'" [alt]="'phone'"></atlas-icon>

        {{connection.phone}}
      </h5>
      <h5>
        <atlas-icon [icon]="'icon-mail-24'" [size]="'large'" [alt]="'email'"></atlas-icon>

        <a [href]="'mailto:' + connection.username">{{connection.username}}</a>
      </h5>
    </div>
  </div>
  <br>
  <div class="mos-u-spacer--padding-top-sm mos-u-spacer--padding-bottom-sm">
    <span class="mos-u-footnote">
      * Changes to user access must be requested by authorised
      signatories.</span>
  </div>
</div>